import React from 'react'

import Layout from '../../components/Layout'
import RecipeRoll from '../../components/RecipeRoll/RecipeRoll'
import "./recipes.scss"

export default class RecipeIndexPage extends React.Component {
  render() {
    return (
      <Layout>
        <div className="recipes-header header-clear">
            <div className="page-width">
                <h1>Latest Recipes</h1>
            </div>
        </div>
        <section className="section">
          <div className="container">
            <div className="content">
              <RecipeRoll />
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}
